var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheSaudiInvestmentBankFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.12155 9.97915C6.29188 11.1495 8.18609 11.1487 9.34961 9.98521C10.5086 8.82625 10.5086 6.9328 9.33824 5.76247C8.18306 4.60729 6.29264 4.61032 5.13368 5.76929C3.97017 6.93204 3.96562 8.82322 5.12155 9.97915Z",
    fill: "#FFD400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98879 5.1696C4.866 5.29239 4.866 5.4925 4.98879 5.61529L4.28083 4.90733C3.74493 4.37144 3.74493 3.4952 4.28083 2.95931L7.2385 0.00012207L10.1977 2.95931C10.7336 3.4952 10.7336 4.37144 10.1977 4.90733L9.48972 5.61529C9.61251 5.4925 9.61251 5.29239 9.48972 5.1696L7.23925 2.91913L4.98879 5.1696Z",
    fill: "#242423"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8795 12.481C7.11978 12.7213 7.23955 13.0389 7.23955 13.3557L7.24106 13.3542C7.2403 13.0374 7.36082 12.7206 7.60111 12.4795L12.2006 7.88004L9.97058 5.65004L11.4297 4.19092L13.8666 6.62785C14.5556 7.31686 14.5549 8.44398 13.8666 9.13224L7.23955 15.7593L0.612461 9.13224C-0.0765496 8.44323 -0.0765496 7.3161 0.612461 6.62785L3.04939 4.19092L4.50852 5.65004L2.27852 7.88004L6.8795 12.481Z",
    fill: "#242423"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheSaudiInvestmentBankFavicon);
export default __webpack_public_path__ + "static/media/the_saudi_investment_bank_favicon.2b4b39254ca013aa1ef09d9f76fb3165.svg";
export { ForwardRef as ReactComponent };